import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import React from 'react'

function FailedToLoad(props: SvgIconProps) {
  return (
    <SvgIcon height="116" viewBox="0 0 150 116" width="150" {...props}>
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="failedToLoad-paint0_linear"
          x1="42.084"
          x2="5.26133"
          y1="-18.06"
          y2="83.072"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="#F4F6FD" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="failedToLoad-paint1_linear"
          x1="99.8977"
          x2="86.4784"
          y1="22.7198"
          y2="58.9993"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id="failedToLoad-paint2_linear"
          x1="99.8977"
          x2="27.011"
          y1="29.8165"
          y2="82.869"
        >
          <stop stopColor="#EFF4FB" />
          <stop offset="1" stopColor="#BACAE9" />
        </linearGradient>
      </defs>
      <path
        clipRule="evenodd"
        d="M32.8299 0C15.6228 0.0342053 6.87271 15.8165 3.84783 22.2471C1.93807 26.3058 0.00808792 31.981 0 38.309V38.3891C0.0141539 48.6312 5.07517 60.5718 23.3943 70.1375C62.0606 83.5773 53.3064 105.184 84.8827 114.561C88.09 115.514 91.4261 115.998 94.7813 116H94.8905C116.988 115.966 138.487 95.6254 147.028 74.1024C153.349 58.1774 150.878 26.6381 126.886 14.851C113.243 8.14673 104.023 10.329 94.5346 12.5113C83.6199 15.021 72.3515 17.5317 53.5885 6.51074C45.6553 1.85295 38.8078 0.0127048 32.9401 0.000977295H32.8299V0Z"
        fill="url(#failedToLoad-paint0_linear)"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M118.999 37.9944C118.999 39.0995 118.104 39.9958 116.999 39.9958L31.0117 39.9999C29.9078 40 29.0126 39.1057 29.0116 38.0018L29.0019 28.0019C29.0009 26.8966 29.8966 26 31.0019 26L116.992 26C118.096 26 118.991 26.8946 118.992 27.9986L118.999 37.9944Z"
        fill="url(#failedToLoad-paint1_linear)"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M119 91.9841C119 93.0886 118.105 93.9842 117 93.9844L31.0133 93.9996C29.9088 93.9998 29.0133 93.1047 29.013 92.0002L29.0005 44.0005C29.0002 42.8957 29.8957 42 31.0005 42L116.991 42C118.095 42 118.991 42.8952 118.991 43.9996L119 91.9841Z"
        fill="url(#failedToLoad-paint2_linear)"
        fillRule="evenodd"
      />
      <path
        d="M61.1789 74.9991C60.6714 75.8878 61.304 77 62.3169 77H86.6831C87.696 77 88.3286 75.8878 87.8211 74.9991L75.6379 53.6651C75.1315 52.7783 73.8685 52.7783 73.3621 53.6651L61.1789 74.9991ZM75.8149 71.6679C75.8149 72.4041 75.2262 73.0009 74.5 73.0009C73.7738 73.0009 73.1851 72.4041 73.1851 71.6679C73.1851 70.9317 73.7738 70.3349 74.5 70.3349C75.2262 70.3349 75.8149 70.9317 75.8149 71.6679ZM75.8149 66.3358C75.8149 67.072 75.2262 67.6688 74.5 67.6688C73.7738 67.6688 73.1851 67.072 73.1851 66.3358V62.3367C73.1851 61.6005 73.7738 61.0037 74.5 61.0037C75.2262 61.0037 75.8149 61.6005 75.8149 62.3367V66.3358Z"
        fill="white"
      />
      <circle cx="36" cy="33" fill="white" r="3" />
      <circle cx="45" cy="33" fill="white" r="3" />
      <circle cx="54" cy="33" fill="white" r="3" />
    </SvgIcon>
  )
}

export default FailedToLoad
